export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const CLOSE_MODAL_SOURCE_CLICK_OUTSIDE = 'CLICK_OUTSIDE';
export const CLOSE_MODAL_SOURCE_CROSS_BUTTON = 'CROSS_BUTTON';
export const CLOSE_MODAL_SOURCE_RELEASE_DRAWER = 'RELEASE DRAWER';
export const MODAL_PROPS_PATH = ['params', 'props'];

export const MODAL_INFO_DIALOG = 'MODAL_INFO_DIALOG';
export const MODAL_ACCOUNT_RECOVERY = 'MODAL_ACCOUNT_RECOVERY';
export const MODAL_ACTIVE_BOOST = 'MODAL_ACTIVE_BOOST';
export const MODAL_ACTIVE_SUPER_BOOST = 'MODAL_ACTIVE_SUPER_BOOST';
export const MODAL_ADD_CARD = 'MODAL_ADD_CARD';
export const MODAL_ADD_TO_HOMESCREEN = 'MODAL_ADD_TO_HOMESCREEN';
export const MODAL_ADD_FACE_PHOTO = 'MODAL_ADD_FACE_PHOTO';
export const MODAL_AGE_GATE = 'MODAL_AGE_GATE';
export const MODAL_AGE_VERIFICATION = 'MODAL_AGE_VERIFICATION';
export const MODAL_AGE_VERIFICATION_EUREKA = 'MODAL_AGE_VERIFICATION_EUREKA';
export const MODAL_AGE_VERIFICATION_POST_ONBOARDING = 'MODAL_AGE_VERIFICATION_POST_ONBOARDING';
export const MODAL_ALL_IN_GENDER = 'MODAL_ALL_IN_GENDER';
export const MODAL_ALL_IN_ORIENTATION = 'MODAL_ALL_IN_ORIENTATION';
export const MODAL_ALL_IN_SAFETY = 'MODAL_ALL_IN_SAFETY';
export const MODAL_ALL_IN_SAFETY_INTERESTED_IN = 'MODAL_ALL_IN_SAFETY_INTERESTED_IN';
export const MODAL_ALTERNATE_PAYMENTS = 'MODAL_ALTERNATE_PAYMENTS';
export const MODAL_APP_REVIEW = 'MODAL_APP_REVIEW';
export const MODAL_ATTACH_A_MESSAGE = 'MODAL_ATTACH_A_MESSAGE';
export const MODAL_AUTO_RENEW_PROMO = 'MODAL_AUTO_RENEW_PROMO';
export const MODAL_AV_PERMISSIONS = 'MODAL_AV_PERMISSIONS';
export const MODAL_BIOMETRICS_CONSENT = 'MODAL_BIOMETRICS_CONSENT';
export const MODAL_BIOMETRICS_LIVENESS_CHECK = 'MODAL_BIOMETRICS_LIVENESS_CHECK';
export const MODAL_BLOCK_USER = 'MODAL_BLOCK_USER';
export const MODAL_BOOST_END = 'MODAL_BOOST_END';
export const MODAL_BOOST_FIRST_TIME = 'MODAL_BOOST_FIRST_TIME';
export const MODAL_BOOST_PAYWALL = 'MODAL_BOOST_PAYWALL';
export const MODAL_BOOST_SUBSCRIPTION_PAYWALL = 'MODAL_BOOST_SUBSCRIPTION_PAYWALL';
export const MODAL_BOOST_UPSELL = 'MODAL_BOOST_UPSELL';
export const MODAL_BOOST_WALLET = 'MODAL_BOOST_WALLET';
export const MODAL_CANCEL_SAVE_OFFER = 'MODAL_CANCEL_SAVE_OFFER';
export const MODAL_CANCEL_SUBSCRIPTION = 'MODAL_CANCEL_SUBSCRIPTION';
export const MODAL_CELEBRATION_LIKES = 'MODAL_CELEBRATION_LIKES';
export const MODAL_CHAT_SUGGESTIONS_CONSENT = 'MODAL_CHAT_SUGGESTIONS_CONSENT';
export const MODAL_CHOOSE_PHOTO = 'MODAL_CHOOSE_PHOTO';
export const MODAL_CONFIRMATION = 'MODAL_CONFIRMATION';
export const MODAL_CONTACT_CARD_EDIT = 'MODAL_CONTACT_CARD_EDIT';
export const MODAL_CONTENT = 'MODAL_CONTENT';
export const MODAL_DYNAMIC_PAYWALL = 'MODAL_DYNAMIC_PAYWALL';
export const MODAL_EDIT_PHOTO = 'MODAL_EDIT_PHOTO';
export const MODAL_ELECTION_CENTER = 'MODAL_ELECTION_CENTER';
export const MODAL_ELECTION_CENTER_SETTINGS = 'MODAL_ELECTION_CENTER_SETTINGS';
export const MODAL_EMAIL_AUTH = 'MODAL_EMAIL_AUTH';
export const MODAL_EMAIL_VERIFICATION = 'MODAL_EMAIL_VERIFICATION';
export const MODAL_EXPIRED_LINK = 'MODAL_EXPIRED_LINK';
export const MODAL_EXPLORE_CATALOG_OPT_IN = 'MODAL_EXPLORE_CATALOG_OPT_IN';
export const MODAL_FILTER_TRAY = 'MODAL_FILTER_TRAY';
export const MODAL_INSENDIO_FULL_SCREEN_V2 = 'MODAL_INSENDIO_FULL_SCREEN_V2';
export const MODAL_MM_FRIEND_NAME = 'MODAL_MM_FRIEND_NAME';
export const MODAL_MM_INFO_SHEET = 'MODAL_MM_INFO_SHEET';
export const MODAL_MM_FREE_SUPERLIKES = 'MODAL_MM_FREE_SUPERLIKES';
export const MODAL_GENDER_SELECT = 'MODAL_GENDER_SELECT';
export const MODAL_GENERIC_DIALOG = 'MODAL_GENERIC_DIALOG';
export const MODAL_GLOBAL_MODE = 'MODAL_GLOBAL_MODE';
export const MODAL_GLOBAL_PASSPORT = 'MODAL_GLOBAL_PASSPORT';
export const MODAL_GOLD_PAYWALL = 'MODAL_GOLD_PAYWALL';
export const MODAL_HOUSE_RULES = 'MODAL_HOUSE_RULES';
export const MODAL_INCENTIVE_REDEMPTION = 'MODAL_INCENTIVE_REDEMPTION';
export const MODAL_INCOGNITO_MODE = 'MODAL_INCOGNITO_MODE';
export const MODAL_INSTAGRAM = 'MODAL_INSTAGRAM';
export const MODAL_INTERESTS = 'MODAL_INTERESTS';
export const MODAL_INTRO_PRICE_AND_SUB_OFFER = 'MODAL_INTRO_PRICE_AND_SUB_OFFER';
export const MODAL_ITS_A_MATCH = 'MODAL_ITS_A_MATCH';
export const MODAL_LANGUAGE_SELECTION = 'MODAL_LANGUAGE_SELECTION';
export const MODAL_LOGIN = 'MODAL_LOGIN';
export const MODAL_MARKETING = 'MODAL_MARKETING';
export const MODAL_MESSAGING_CONSENT = 'MODAL_MESSAGING_CONSENT';
export const MODAL_MUTUAL_FRIENDS_OPT_IN = 'MODAL_MUTUAL_FRIENDS_OPT_IN';
export const MODAL_OFFER = 'MODAL_OFFER';
export const MODAL_ONBOARDING = 'MODAL_ONBOARDING';
export const MODAL_ONBOARDING_UPDATES = 'MODAL_ONBOARDING_UPDATES';
export const MODAL_ORIENTATION = 'MODAL_ORIENTATION';
export const MODAL_OUTAGE_PREAUTH = 'MODAL_OUTAGE_PREAUTH';
export const MODAL_OUTAGE_REAUTH = 'MODAL_OUTAGE_REAUTH';
export const MODAL_OUT_OF_LIKES = 'MODAL_OUT_OF_LIKES';
export const MODAL_INSENDIO_PARTIAL_SCREEN_V2 = 'MODAL_INSENDIO_PARTIAL_SCREEN_V2';
export const MODAL_PAYMENT_DELETED = 'MODAL_PAYMENT_DELETED';
export const MODAL_PAYWALL = 'MODAL_PAYWALL';
export const MODAL_PERSONALIZED_OFFER = 'MODAL_PERSONALIZED_OFFER';
export const MODAL_PHOTO_ACTIONS = 'MODAL_PHOTO_ACTIONS';
export const MODAL_PLATINUM_PAYWALL = 'MODAL_PLATINUM_PAYWALL';
export const MODAL_CONTENTFUL_STICKER_CENTER = 'MODAL_CONTENTFUL_STICKER_CENTER';
export const MODAL_PRIDE_CENTER_2023 = 'MODAL_PRIDE_CENTER_2023';
export const MODAL_PRIMETIME_BOOST = 'MODAL_PRIMETIME_BOOST';
export const MODAL_PRIMETIME_BOOST_UPSELL = 'MODAL_PRIMETIME_BOOST_UPSELL';
export const MODAL_PRIORITY_LIKES = 'MODAL_PRIORITY_LIKES';
export const MODAL_PRIVACY_PREFERENCES = 'MODAL_PRIVACY_PREFERENCES';
export const MODAL_READ_RECEIPT_PAYWALL = 'MODAL_READ_RECEIPT_PAYWALL';
export const MODAL_REGISTRATION_CONSENT = 'MODAL_REGISTRATION_CONSENT';
export const MODAL_RELATIONSHIP_INTENT = 'MODAL_RELATIONSHIP_INTENT';
export const MODAL_REPORT_SELECTED_MESSAGES = 'MODAL_REPORT_SELECTED_MESSAGES';
export const MODAL_REPORT_SOMEONE = 'MODAL_REPORT_SOMEONE';
export const MODAL_REPORT_SOMEONE_V2 = 'MODAL_REPORT_SOMEONE_V2';
export const MODAL_REPORT_USER_DYNAMIC = 'MODAL_REPORT_USER_DYNAMIC';
export const MODAL_RESTORE_ACCOUNT = 'MODAL_RESTORE_ACCOUNT';
export const MODAL_SAFETY_TOOLKIT = 'MODAL_SAFETY_TOOLKIT';
export const MODAL_SAFETY_TOOLKIT_V2 = 'MODAL_SAFETY_TOOLKIT_V2';

export const MODAL_SELFIE_CHALLENGE_V2 = 'MODAL_SELFIE_CHALLENGE_V2';
export const MODAL_SELFIE_VERIFICATION_V1 = 'MODAL_SELFIE_VERIFICATION_V1';
export const MODAL_SELFIE_VERIFICATION_V2 = 'MODAL_SELFIE_VERIFICATION_V2';
export const MODAL_SELFIE_VERIFICATION_V2_DELETE_PHOTO =
  'MODAL_SELFIE_VERIFICATION_V2_DELETE_PHOTO';
export const MODAL_SMS_AUTH = 'MODAL_SMS_AUTH';
export const MODAL_SONGKRAN_CENTER_2024 = 'MODAL_SONGKRAN_CENTER_2024';
export const MODAL_INDIA_ELECTION_CENTER_2024 = 'MODAL_INDIA_ELECTION_CENTER_2024';
export const MODAL_JAPAN_MATCH_FES_CENTER_2024 = 'MODAL_JAPAN_MATCH_FES_CENTER_2024';
export const MODAL_KOREAN_BASEBALL_CENTER_2024 = 'MODAL_KOREAN_BASEBALL_CENTER_2024';

export const MODAL_STACKS_UTIL = 'MODAL_STACKS_UTIL';
export const MODAL_SUPERLIKE_PAYWALL = 'MODAL_SUPERLIKE_PAYWALL';
export const MODAL_SUPERLIKE_UPSELL_MODAL = 'MODAL_SUPERLIKE_UPSELL_MODAL';
export const MODAL_SUPER_BOOST_END = 'MODAL_SUPER_BOOST_END';
export const MODAL_SUPER_BOOST_PAYWALL = 'MODAL_SUPER_BOOST_PAYWALL';
export const MODAL_TERMS_OF_SERVICE = 'MODAL_TERMS_OF_SERVICE';
export const MODAL_TOKEN_DETAILS = 'MODAL_TOKEN_DETAILS';
export const MODAL_UPDATE_EMAIL = 'MODAL_UPDATE_EMAIL';
export const MODAL_VOTER_REGISTRATION = 'MODAL_VOTER_REGISTRATION';
export const MODAL_WARNING = 'MODAL_WARNING';
export const MODAL_WORK_MODE = 'MODAL_WORK_MODE';
export const MODAL_Y_FOR_X_BOOST = 'MODAL_Y_FOR_X_BOOST';
